import {
  envKeys,
  smokeballApiKeys,
  googleMapApiKeys,
  slackApiKeys,
  amplitudeApiKey,
  captchaKeys,
  launchDarklyKeys,
} from "@smart/bridge-env-types-basic";
import { buildScheduleHandlerDef } from "@smart/itops-constructs-basic";

export const dataSyncLambda = buildScheduleHandlerDef({
  envKeys,
  handler: {
    deployable: "data-sync",
    pkg: "@smart/manage-data-sync-lambda",
    env: [...smokeballApiKeys, "SmokeballDefaultAccountId"],
  } as const,
});

export const formVersionLambda = buildScheduleHandlerDef({
  envKeys,
  handler: {
    deployable: "formVersion",
    pkg: "@smart/manage-form-version-lambda",
    env: [],
  } as const,
});

export const apiHealthCheckLambda = buildScheduleHandlerDef({
  envKeys,
  handler: {
    deployable: "apiHealthCheck",
    pkg: "@smart/manage-api-health-check-lambda",
    env: [
      ...googleMapApiKeys,
      ...slackApiKeys,
      amplitudeApiKey,
      ...captchaKeys,
      ...launchDarklyKeys,
    ],
  } as const,
});

export const reminderScannerLambda = buildScheduleHandlerDef({
  envKeys,
  handler: {
    deployable: "reminder-scanner",
    pkg: "@smart/manage-reminder-scanner-lambda",
    env: [...launchDarklyKeys],
  } as const,
});
